import { TFunction } from 'i18next';

import { createHandle } from 'services/breadcrumbs/breadcrumbs';
import { TransactionsRoutes } from 'support/types';

import { BlockedTransactions } from '../BlockedTransactions/BlockedTransactions';

export const ExpiredTransactions = () => {
  return <BlockedTransactions expired={true} />;
};

ExpiredTransactions.handle = createHandle(() => ({
  label: (t: TFunction) => t('transactions:list.expiredBreadcrumb'),
  to: TransactionsRoutes.expired,
  key: TransactionsRoutes.expired,
}));
